import { render, staticRenderFns } from "./AppraiserFormWrapper.vue?vue&type=template&id=5bdf44e8&"
import script from "./AppraiserFormWrapper.vue?vue&type=script&lang=ts&"
export * from "./AppraiserFormWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports